export const SOURCE = {
  customer: 'CUSTOMER',
  plaid: 'PLAID',
  xero: 'XERO',
};

export const TRANSACTION_TYPES = {
  receive: 'RECEIVE',
  spend: 'SPEND',
};

export const RECONCILE_STATUS = {
  reconciled: 'reconciled',
  unreconciled: 'unreconciled',
};
